export default {
  base: 1,
  soft: 2,
  medium: 3,
  hard: 8,
  over: 9,
}
